// This module provide references for libraries
// that are not part of the module, they get injected from
// Agent Dashboard current Struts/Freemarker framework.

const {
    $, // jQuery
    moment, // moment.js
    formatters, // formatters library
    validators, // validators library
    model,
    showSpinner, stopSpinner,
    initDefaultPopovers,
    DISPLAY_DATE_FORMAT, DISPLAY_DATE_TIME_FORMAT,
    logout,
    ga
} = window;

export {
    $, moment,
    showSpinner, stopSpinner,
    model,
    formatters,
    validators,
    initDefaultPopovers,
    DISPLAY_DATE_FORMAT, DISPLAY_DATE_TIME_FORMAT,
    logout,
    ga
};
